// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__Akb41","layout__header":"styles_layout__header__7kZ_w","layout__logo":"styles_layout__logo__29Q5_","layout__main":"styles_layout__main__Yru_I"};